import { render, staticRenderFns } from "./UcInactive.yaml?vue&type=template&id=2d5ffdac&component"
import script from "./UcInactive.yaml?vue&type=script&lang=ts&component"
export * from "./UcInactive.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports